'use client'

import { useMemo } from 'react'
import { useNavigationSnapshot } from '@/hooks/navigation/useNavigationSnapshot'
import { usePresenceSnapshot } from '@/hooks/presence/usePresenceSnapshot'
import { useSystemUsers } from '@/hooks/useSystemUsers'
import { usuariosDoCanal } from '@/lib/navigation/navegacao'
import { montarPresencaNoCanal, type PresencaNoCanal } from '@/lib/navigation/presencaNoCanal'
import type ISystemUser from '@/types/SystemUser'

/**
 * Quem está no canal agora (canal aberto ∪ chat dele aberto, este em rosa), pronto
 * pro `ChannelPresenceAvatars`. Só hooks
 * app-wide (navegação, presença, directory) — funciona no BrandMenu, fora do
 * `ChatBotProvider`. Gate triplo herdado do `useNavigationSnapshot`.
 */
export function useChannelPresence(channelId: string): readonly PresencaNoCanal[] {
  const { porCanal } = useNavigationSnapshot()
  const { byId } = usePresenceSnapshot()
  const { systemUsers } = useSystemUsers()
  const diretorio = useMemo(
    () => new Map<string, ISystemUser>(systemUsers.map((u) => [u.db_id, u])),
    [systemUsers],
  )
  const canal = porCanal.get(channelId)
  return useMemo(() => {
    const { usuarios, emChat } = usuariosDoCanal(canal)
    return montarPresencaNoCanal(usuarios, byId, diretorio, emChat)
  }, [canal, byId, diretorio])
}
